const triggerEvent = (
  name: string,
  el: EventTarget = document,
  params: unknown = {},
  config: CustomEventInit = { bubbles: true, cancelable: true }
): void => {
  el.dispatchEvent(new CustomEvent(name, { ...config, detail: params }));
};

/**
 * Safely remove the d-none class from an element if it exists.
 */
const show = (selector: string): void => {
  document.querySelector(selector)?.classList.remove('d-none');
};

/**
 * Safely add the d-none class to an element if it exists.
 */
const hide = (selector: string): void => {
  document.querySelector(selector)?.classList.add('d-none');
};

export { triggerEvent, show, hide };
